import { IncomingMessage } from 'http'
import axios from 'axios'

export const isAuthLoggedIn = (req: IncomingMessage) => (req.headers?.cookie || '').indexOf('corp_session') !== -1

export const getUserDetails = async (req: IncomingMessage) => {
  const url = `${process.env?.NEXT_PUBLIC_INTERNAL_AUTH_API_BASE}`
  return await axios
    .get(url, {
      headers: {
        Cookie: req?.headers?.cookie ?? '',
      },
    })
    .then(res => {
      const userName: string = res.data.first_name + ' ' + res.data.last_name
      const userEmail: string = res.data.email
      return { userName, userEmail }
    })
    .catch(err => {
      console.log('res', err)
      const userName: string = ''
      const userEmail: string = ''
      return { userName, userEmail }
    })
}
